import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=072acf8e&"
import script from "./faq.vue?vue&type=script&lang=ts&"
export * from "./faq.vue?vue&type=script&lang=ts&"
import style0 from "./faq.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports